<template>
  <div class="animated fadeIn list-of-receiving">
    <b-card>
      <div slot="header">Receiving List
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Receiving Form</b-dropdown-item>
            <b-dropdown-item @click="printjv" :disabled="(model.isposted == 0)">Jurnal Voucher</b-dropdown-item>
          </b-dropdown>

          <b-dropdown text="Posting" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="(model.isposted == 1)">Posting</b-dropdown-item>
            <b-dropdown-item @click="posting" :disabled="(model.isposted != 1)">Un Posting </b-dropdown-item>
          </b-dropdown>
          <!-- <button class="btn btn-primary mr-1" @click="posting()">
              <i class="fa fa-paper-plane"></i> {{postingTxt}}
          </button> -->
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Order Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="6">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Receiving No. &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.RecivNo" placeholder="Receiving Number"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>          
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-row>
              <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Status &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.status" :plain="true" :options="postingStatus"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
        </b-col>
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Delivery No.&nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.DoNumber" placeholder="Delivery Number"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>            
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
                <b-form-input v-model="tblData.item" placeholder="Material/Service Name"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>      
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.isposted == 1)" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.isposted != 1)"  style="padding:0 !important;">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Receiving Form</b-dropdown-item>
          <b-dropdown-item @click="rowPrintJv(data.item)" href="#" style="padding:0 !important;">Print Journal Voucher</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(RecivDate)="data">
          {{ data.item.RecivDate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(RecivNo)="data">
          <div v-if="data.item.isposted==0" style="background-color:yellow;">           
            {{ data.item.RecivNo}}
          </div>
          <div v-else>{{ data.item.RecivNo}}</div>
        </template>

        <template v-slot:cell(nilainett)="data">
          {{data.item.nilainett | numFormat}}
        </template>
        <template v-slot:cell(nilaippn)="data">
          {{data.item.nilaippn | numFormat}}
        </template>
        <template v-slot:cell(nilaidue)="data">
          {{data.item.nilaidue | numFormat}}
        </template>
      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>        
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <!-- <b-modal v-model="showPostingConfirm" title="Send to Workflow for Approval Process?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Sent to Workflow for Approval Process?</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal> -->
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Confirmation for Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">
          <ul>
            <li>Data GL Journal will be removed</li>
            <li>Data AP Invoice will be removed</li>
            <li>Data Fixed Asset will be removed</li>
            <li>Data Inventory will be removed </li>
          </ul>           
        </p>
      </b-modal>


  </div>
</template>

<style lang="scss">
  .list-of-receiving {
    table {
      // td:nth-child(1) {
      //   width: auto;
      // }
      // td:nth-child(2) {
      //   width: auto;
      // }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
   
  }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import procreceiv from "../../apis/procreceiv";
import procure from "../../apis/procure";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      postingTxt:'Posting',
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      postingStatus : dropdown.postingStatus,
      pagination: false,
      limit:15,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,        
        sortBy: null,
        sortDesc: false,
        DimCol:'Dim1',
        status:'',
        postgroup:''
      },
      model:{},
      postGroups:[]
      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "RecivNo",
            label: "Receiving Number",
            thStyle: "width:110px",
            sortable: true
          },
          {
            key: "RecivDate",
            thStyle: "width:90px",
            label: "Receiving Date",
            sortable: true
          },
          {
            key: "orderno",
            label: "P.O Number",
            sortable: true
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "P.O Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            sortable: true
          },
          {
            key: "requestno",
            label: "Requesition #",
            sortable: true
          },
          {
            key: "remark",
            label: "Description",
            sortable: true
          },
          {
            key: "nomorap",
            label: "Posting No.",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },       

  },
  created: async function(){
      // const accList = await procreceiv.postgroup();
      const accList = await procure.postgroup();
      this.postGroups = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
        // const tglaktif = moment(new Date(), 'YYYY-MM-DD');
        // this.tblData.tgl1 =  tglaktif.startOf('month').format('YYYY-MM-DD');
        // this.tblData.tgl2 =  tglaktif.endOf('month').format('YYYY-MM-DD');
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
  

    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.recivpolist) {
            this.tblData[key] = filter.recivpolist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.recivpolist.tgl1 || '';
          this.tblData.tgl2=filter.recivpolist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.recivpolist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await procreceiv.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await procreceiv.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.RecivNo='';
        this.tblData.DoNumber='';
        this.tblData.DimVal= '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.status= '';
        this.tblData.vendor= '';
        this.tblData.uraian=  '';
        this.tblData.item=  '';
        this.tblData.postgroup=  '';
    },
     
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'requestno','RecivNo', 'DoNumber', 'item', 'status'];
      let filtered = false;
      const recivpolist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              recivpolist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          recivpolist.page=this.tblData.page;
          recivpolist.limit=this.tblData.limit;
          recivpolist.sortBy=this.tblData.sortBy;
          recivpolist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.recivpolist=recivpolist;
          this.$store.commit("filter", filter);
      }
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintJv(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add(){
      this.saveFilter();
      router.push("receiving-form");
    },
    edit: function() {
        if (this.model.RecivKey) {
          this.saveFilter();
          router.push({name :'logistic.receivingfrm', params: { RecivKey: this.model.RecivKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await procreceiv.remove(this.model);
      this.refresh();
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log(error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }        
      }
    },

    rowClicked(record, index) {
      if (record) {
        if ((record.isposted || 0) == 0) {
            this.postingTxt = 'Posting';
        }
        if (record.isposted == 1) {
            this.postingTxt = 'Un Posting';
        }
      } 

      // if (this.model.RecivKey == record.RecivKey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    posting: async function () {
        if (this.model) {
            if ((this.model.isposted || 0) == 0) {
              this.saveFilter();
              router.push({name :'logistic.receivingposting', params: { RecivKey: this.model.RecivKey}});
            }
            if (this.model.isposted == 1) {
               if (this.model.partialRcv) {
                  this.showUnpostConfirm = true;
               } else {
                 toastr.error('Only PARTIAL RECEIVING (AP UNBILL) can be unposted form this Menu','ERROR MESSAGE',10000);
               }
            }
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    // postingData: async function(){
    //     this.isLoading=true;
    //     try {
    //         await procreceiv.posting(this.model);
    //         this.model.posting=1;
    //         this.print();
    //         this.isLoading=false;
    //         this.refresh();
    //     } catch (error) {
    //         this.isLoading=false;
    //         if (error.message) {
    //             toastr.error(error.message,'ERROR MESSAGE',10000);
    //         } else {
    //             toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //         }
    //     }
    // },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await procreceiv.postingUndo(this.model);
            this.model.isposted=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await procreceiv.print(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printjv: async function()
    {
      if (this.model) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await procreceiv.printjv(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await procreceiv.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        // router.push({name:'procurement.home'});
          router.push("home");
    }

  }
};
</script>
